/**
 * UID-335 follow-up — the ONE place that decides how a resolved thumbnail
 * URL (`LibraryPartRow.thumbnailUrl` / `PartDetail.thumbnailUrl` / any other
 * surface's equivalent sibling-of-`sourceable` field) becomes a SAFE
 * `Sourceable.imageRef` value, wherever a caller needs to bind one onto an
 * `RfqBundleItem`/`ReviewLineSourceable`-shaped object.
 *
 * That resolved URL is EITHER an already-safe root-relative asset path (a
 * catalog/demo-fixture part's own pre-seeded path, e.g.
 * `/assets/mc-frame/mcf037.jpg`) OR a real generated CAD thumbnail's absolute
 * presigned S3 URL (`resolveThumbnailUrls`, UID-330) — and a caller can't
 * tell which without checking. Several call sites independently got this
 * wrong before this was extracted:
 *
 * - `AddPartsModal.tsx`'s `isSafeCatalogImageRef`/`isSafePartImageRef` only
 *   ever authorize a root-relative same-origin path (Gate-5 N1) — passing an
 *   absolute URL through unchanged gets it silently rejected there.
 * - `add-parts-search.ts` first routed EVERY thumbnailUrl through the
 *   same-origin proxy unconditionally, which 404s for an already-root-
 *   relative fixture path (the proxy only ever resolves a real UUID-shaped
 *   generated-thumbnail id).
 *
 * This function is the single place that gets the distinction right: use a
 * root-relative value as-is; route an absolute one through the same-origin
 * redirect (`GET /api/uploads/thumbnails/{id}`, `uploads-routes.ts`) instead
 * of using it directly.
 */
export function toSafeImageRef(
  thumbnailUrl: string | null | undefined,
  sourceableId: string,
): string | undefined {
  if (!thumbnailUrl) {
    return undefined
  }
  return thumbnailUrl.startsWith('/') ? thumbnailUrl : `/api/uploads/thumbnails/${sourceableId}`
}
